import type { SVGProps } from "react";

export function IconWhitePin(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_9190_45194)">
        <path
          d="M28 16C30.2091 18.2091 30.2091 21.7909 28 24C25.7909 26.2091 22.2091 26.2091 20 24C17.7909 21.7909 17.7909 18.2091 20 16C22.2091 13.7909 25.7909 13.7909 28 16Z"
          stroke="#23232C"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_9190_45194">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
